import { ReactElement, ReactNode } from 'react';
import { MoreOutlined } from '@ant-design/icons';
import { MenuProps, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from 'common/components/antd/Button/Button';
import { Dropdown } from 'common/components/antd/Dropdown/Dropdown';
import {
  SContainer,
  SMenuTrigger,
  SLabel,
  SDangerItem,
} from './role-header.style';
import { ERoleMenuItemKey } from '../../table.enums';

export const RoleHeaderComponent = ({
  children,
  onMenuItemClick,
}: {
  children: ReactNode;
  onMenuItemClick: MenuProps['onClick'];
}): ReactElement => {
  const { t } = useTranslation();
  const menu: MenuProps = {
    items: [
      {
        label: t('usrRoleMng.roles.table.action.duplicate'),
        key: ERoleMenuItemKey.Duplicate,
      },
      {
        label: t('usrRoleMng.roles.table.action.audit'),
        key: ERoleMenuItemKey.Audit,
      },
      {
        label: <SDangerItem>{t('usrRoleMng.roles.table.action.delete')}</SDangerItem>,
        key: ERoleMenuItemKey.Delete,
      },
    ],
    onClick: onMenuItemClick,
  };
  return (
    <SContainer>
      <SMenuTrigger>
        <Dropdown menu={menu}>
          <Button type="text" icon={<MoreOutlined />} />
        </Dropdown>
      </SMenuTrigger>
      <div>
        <SLabel type="secondary">{t('usrRoleMng.roles.table.column.name')}</SLabel>
      </div>
      <div>
        <Typography.Text strong>{children}</Typography.Text>
      </div>
    </SContainer>
  );
};
